/**
 * Institution Usage Hook
 */

import { useQuery } from '@tanstack/react-query'
import { tokenStorage } from '@/lib/api'
import * as service from './institution-usage.service'

export function useInstitutionUsage(institutionId: string | null) {
  const hasToken = !!tokenStorage.getAccessToken()
  return useQuery({
    queryKey: institutionId ? ['institution-usage', institutionId] : ['noop'],
    queryFn: () => service.getInstitutionUsage(institutionId as string),
    enabled: hasToken && !!institutionId,
    staleTime: 60 * 1000,
  })
}
